// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1QS_4","tab":"ProcedureTabs_tab__3lQPO"};